import React, { useEffect } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom'; 
import { FormattedMessage } from 'react-intl'; 
import PanolGrid from '../panol2/PanolGrid.jsx';

const Panol2 = ({ match }) => { 

  useEffect(() => {
    document.getElementsByClassName('panol2')[0].classList.add('open');
  }, []);

  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage
              id="panol.header_administracion de Panol"
              defaultMessage="Administración de Pañol"
            />
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          <Route exact path={`${match.url}`} component={PanolGrid} />
          <Route exact path={`${match.url}/stock`} component={PanolGrid} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(Panol2);
